const id_facility_category = {
    "": 'kategori fasilitas',
    add: 'tambah kategori fasilitas',
    edit: 'ubah kategori fasilitas',

    label: {
        name: 'nama kategori fasilitas'
    },

    error: {
        create: "Gagal membuat kategori",
        delete: "Gagal menghapus kategori",
        edit: "Gagal mengubah kategori",
        name: "Nama kategori tidak boleh kosong."
    },
    success: {
        create: "Berhasil membuat kategori",
        delete: "Berhasil menghapus kategori",
        edit: "Berhasil mengubah kategori",
    },
}

export default id_facility_category;